/* @ngInject */
function AnalyticsInsightsPopupController ($rootScope, $scope, $state, $translate, $sce, $window, AnalyticsService, SegmentService, ToastService, Utils) {
  const start = new Date(new Date().setDate(new Date().getDate() - 30)).toISOString() // last 30 days
  const end = new Date().toISOString() // today

  const api = {
    _getUserLocale,
    _successGetUserLocale,
    _getInsights,
    _successGetInsights,
    _errorGetInsights,
    _finallyGetInsights,
    _mountCardItems,
    _getDescription
  }

  $scope.flags = {
    loading: false,
    noData: false,
    popup: {
      show: 'closed'
    }
  }

  $scope.cardItems = []
  $scope.description = ''
  $scope.locale = ''

  this.getApi = () => api

  activate()

  function activate () {
    api._getUserLocale()
  }

  $scope.togglePopup = () => {
    if ($scope.flags.popup.show === 'closed') {
      $scope.flags.popup.show = 'opened'
    } else {
      $scope.flags.popup.show = 'closed'
    }
  }

  $scope.openIntercomSurvey = () => {
    $scope.togglePopup()
    $window.open('https://app.deskfy.io/home?intercom_survey_id=35992097', '_blank')
    SegmentService.track('analytics-widget-feedback-click')
  }

  $scope.goToAnalyticsOverview = (type) => {
    const analyticsTypes = {
      'arts-templates': 'arts-overview',
      'arts-approvals': 'arts-templates',
      checklists: 'checklists-overview',
      announcements: 'announcements-overview',
      workflow: 'workflow-overview',
      'workflow-boards': $scope.params?.boardSlug,
      'workflow-requests': 'workflow-requests-received'
    }

    const defaultSlug = 'overview'

    $state.go('analytics.dashboard', {
      slug: analyticsTypes[String(type)] || defaultSlug
    })

    SegmentService.track('analytics-widget-seemore-click')
  }

  function _getUserLocale () {
    $scope.flags.loading = true

    $rootScope.getUser().then(api._successGetUserLocale)
  }

  function _successGetUserLocale ({ locale }) {
    $scope.locale = locale
    $scope.description = $sce.trustAsHtml(api._getDescription(locale))

    api._getInsights({
      ...$scope.params,
      start,
      end,
      maxInsights: 2
    })
  }

  function _getInsights (params) {
    AnalyticsService.getInsights($scope.type, params)
      .then(api._successGetInsights)
      .catch(api._errorGetInsights)
      .finally(api._finallyGetInsights)
  }

  function _successGetInsights (response) {
    if (!response.length) {
      $scope.cardItems = []
      $scope.flags.noData = true
      return
    }

    $scope.cardItems = api._mountCardItems(response)
  }

  function _errorGetInsights (error) {
    console.log({ error })
    $scope.cardItems = []
    $scope.flags.noData = true
    ToastService.defaultErrorToast()
  }

  function _finallyGetInsights () {
    $scope.flags.loading = false
  }

  function _getDescription (locale) {
    const startDayOptions = {
      day: 'numeric',
      month: 'numeric'
    }

    const endDayOptions = {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric'
    }

    const startDay = Utils.formatDate(start, locale, startDayOptions)
    const endDay = Utils.formatDate(end, locale, endDayOptions)

    const description = $translate.instant('analyticsInsights.popup.description', {
      startDay,
      endDay
    })

    return description
  }

  function _mountCardItems (response) {
    const maxCardsLength = 4

    if (response.length === maxCardsLength) {
      const lastIndex = response.length - 1
      const lastCard = response[lastIndex]

      const cardItems = response.map(card => {
        if (card.id === lastCard.id) {
          return {
            ...card,
            isLastCard: true
          }
        }

        return {
          ...card,
          isLastCard: false
        }
      })

      return cardItems
    }

    return response
  }
}

export { AnalyticsInsightsPopupController }
